export const postFormDataHeaders = {
  'Content-Type': 'multipart/form-data',
  'Accept': '*',
};

export const defaultHeaders = {
  'Content-Type': 'application/json',
  'Accept': '*',
};